import { Link } from "react-router-dom";
import IntensityMeter from "@/components/IntensityMeter";
import { catLabel, regionLabel, t } from "@/lib/i18n";
import { useApp } from "@/context/AppContext";

export default function WordCard({ word, idx = 0 }) {
  const { lang } = useApp();
  const tr = word.translations?.[lang] || word.translations?.no || word.translations?.en || "";
  return (
    <Link
      to={`/word/${word.id}`}
      data-testid={`word-card-${word.word.toLowerCase().replace(/\s+/g, "-")}`}
      style={{ animationDelay: `${idx * 40}ms` }}
      className="word-card rise group block bg-white border border-gray-200 rounded-2xl p-7 hover:shadow-sm"
    >
      <div className="flex items-start justify-between mb-4">
        <span className="text-[10px] tracking-eyebrow font-medium text-gray-500">
          {catLabel(word.category, lang)}
        </span>
        {word.region && (
          <span className="text-[10px] font-mono-code text-gray-400 uppercase">
            {regionLabel(word.region, lang)}
          </span>
        )}
      </div>
      <h3 className="font-serif-display text-4xl sm:text-5xl font-bold tracking-tighter leading-none text-gray-900 group-hover:text-[#E85D04] transition-colors">
        {word.word}
      </h3>
      <p className="mt-5 text-sm text-gray-600 line-clamp-2 leading-relaxed">{tr}</p>
      <div className="mt-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-[10px] tracking-eyebrow text-gray-500">
            {t("intensity_label", lang)}
          </span>
          <span className="text-[10px] font-mono-code text-gray-500">
            {word.intensity_avg ? word.intensity_avg.toFixed(1) : "—"} · {word.intensity_votes_count}{" "}
            {t("votes", lang)}
          </span>
        </div>
        <IntensityMeter value={word.intensity_avg || 0} size="sm" />
      </div>
    </Link>
  );
}
